import { code } from "@spscommerce/utils";

export const SpsDatepickerExamples = {
    basic: {
        label: "Basic",
        description: code`<p>info about basic datepicker</p>`,
        examples: {
            basic: {
                template: code`
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-2">
                                <sps-datepicker aria-label="Choose a date" formControlName="datepicker" id="basicDatepicker"></sps-datepicker>
                            </div>
                        </div>
                        <br />
                        selected date  (serialized from moment objects):<br />
                        {{ form.get("datepicker").value | json }}
                    </form>
                `,
                class: code`
                    class DemoComponent {
                        form: FormGroup;
                        constructor(fb: FormBuilder) {
                            this.form = fb.group({
                                datepicker: []
                            });
                        }
                    }
                `
            }
        }
    },
    minMax: {
        label: "Min Max",
        description: code`<p>info about datepicker with min and max dates</p>`,
        examples: {
            basic: {
                template: code`
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-2">
                                <sps-datepicker aria-label="Choose a date" formControlName="datepickerMinMax"
                                    minDate="2018-02-04"
                                    maxDate="2018-04-15">
                                </sps-datepicker>
                            </div>
                        </div>
                    </form>
                `,
                class: code`
                    class DemoComponent {
                        form: FormGroup;
                        constructor(fb: FormBuilder) {
                            this.form = fb.group({
                                datepickerMinMax: []
                            });
                        }
                    }
                `
            }
        }
    },
    disabled: {
        label: "Disabled",
        description: code`<p>info about disabled datepicker</p>`,
        examples: {
            basic: {
                template: code`
                    <!-- Disabled via Reactive Forms -->
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-2">
                                <sps-datepicker aria-label="Choose a date" formControlName="datepickerDisabled" id="disabledDatepicker">
                                </sps-datepicker>
                            </div>
                        </div>
                    </form>
                `,
                class: code`
                    class DemoComponent {
                        form: FormGroup;
                        constructor(fb: FormBuilder) {
                            this.form = fb.group({
                                datepickerDisabled: [{ value: moment(), disabled: true }],
                            });
                        }
                    }
                `
            }
        }
    },
    withLabel: {
        label: "With Label",
        description: code`<p>info about datepicker with label</p>`,
        examples: [{
            template: code`
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-2">
                            <sps-label for="datepickerWithLabel">Date </sps-label>
                            <sps-datepicker aria-label="Choose a date" formControlName="datepickerWithLabel">
                            </sps-datepicker>
                        </div>
                    </div>
                </form>
            `,
            class: code`
                class DemoComponent {
                    form: FormGroup;
                    constructor(fb: FormBuilder) {
                        this.form = fb.group({
                            datepickerWithLabel: [moment(), Validators.required]
                        });
                    }
                }
            `
        }]
    }
};
